import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
    Route,
    Redirect as RouterRedirect,
    Switch,
    withRouter
} from 'react-router-dom';
import {connect} from 'react-redux';
import Loadable from 'react-loadable';

import Header from '../../components/Header';
import Toolbar from '../../components/Toolbar';
import Footer from '../../components/Footer';
import Scoreboard from '../../components/Scoreboard';
import Redirect from '../../components/Redirect';
import RoutesC from '../../constants/routes';
import Cx from 'classnames';
import * as AuthActions from  '../../actions/auth';
import * as intlActions from  '../../actions/intl';
import * as appActions from  '../../actions/app';
import * as userActions from  '../../actions/user';
import * as headerActions from  '../../actions/header';
import Alert from '../../components/Alert';
import ServiceCatalog from '../../components/ServiceCatalog';
import LogPageView from '../AnalyticsWrapper';
import Style from './style.scss';
import {ThemeProvider} from 'styled-components';
import styled from 'styled-components';
import C from '../../constants/app';
import Charger from '../../components/utils/Charger';
import {setSessionID, parseQueryString} from '../../utils/helpers';
import 'react-select/dist/react-select.css';
// require('bootstrap-loader');
import Chatbot from '../../components/chatbot';
import Authorize from '../../containers/Authorization';
import { fetchMixpanelConfig, initializeMixpanel, identifyMixpanelUser, isMixpanelReady } from '../../utils/setupMixpanel';
import { getTrackEventContext } from '../../actions/platformIntegration';
import { getModuleFromPath, getPageFromPath } from '../../utils/getModuleFromPath';
import { setGlobalContextProperty, trackPageView } from '../../utils/mixpanelUtils';

const Home = Loadable({
                          loader: () => import(/* webpackChunkName: 'home' */ '../../components/Home') ,
                          loading: Charger
                      });
const Iframe = Loadable({
                            loader: () => import(/* webpackChunkName: 'iframeComp' */ '../../components/Iframe'),
                            loading: Charger
                        });
const SearchResult = Loadable({
                                  loader: () => import(/* webpackChunkName: 'search' */ '../../components/SearchResult'),
                                  loading: Charger
                              });
const SRview = Loadable({
                            loader: () => import(/* webpackChunkName: 'srView' */ '../../components/SRview'),
                            loading: Charger
                        });
const MySettings = Loadable({
                                loader: () => import(/* webpackChunkName: 'settings' */ '../../components/MySettings'),
                                loading: Charger
                            });


const StyledDiv = styled.div`
	background-color: ${props => props.theme.pageBackground};
	color: ${props => props.theme.textColor}; 
`;

class App extends Component {

    constructor(...args) {
        super(...args);
        //to prevent redundant component mounting after app re-rendering
        this.withLogHome = LogPageView(Home);
        this.withLogIframe = LogPageView(Iframe);
        this.withLogSearchResult = LogPageView(SearchResult);
        this.withLogScoreboard = LogPageView(Scoreboard);
        this.withLogSRview = LogPageView(SRview);
        this.withLogRedirect = LogPageView(Redirect);
        this.withLogMySettings = LogPageView(MySettings);
        this.withLogServiceCatalog = LogPageView(ServiceCatalog);
    }

    componentWillMount() {
        this.props.dispatch(appActions.getSSPPermissions());
        let queryStr = parseQueryString(this.props.location.search);
        this.props.dispatch(appActions.getActiveTheme(queryStr.preview, queryStr.themeId));
        this.props.dispatch(appActions.getSSPPreferences());
    }

    componentDidMount() {
        this.registerMessageHandler();
        this.props.dispatch(headerActions.getUserLogo());
        this.props.dispatch(userActions.getUserDetails());
        this.props.dispatch(intlActions.initUserIntl());
        this.props.dispatch(AuthActions.keepAliveInterval());
        setSessionID();
    }

    componentWillReceiveProps(nextProps) {
        const canSend = nextProps.permissionsData && nextProps.permissionsData.canSendAnalytics;
        if (canSend && !this.mixpanelStarted && !this.mixpanelStarting) {
            this.setupMixpanelAnalytics();
        }
    }

    async setupMixpanelAnalytics() {
        if (process.env.NODE_ENV === 'development') {
            return;
        }
        this.mixpanelStarting = true;
        try {
            const config = await fetchMixpanelConfig();
            if (!config) {
                return;
            }
            initializeMixpanel(config);
            // initializeMixpanel swallows its own failures (missing proxyHost, a
            // thrown mixpanel.init) and signals success only via isMixpanelReady().
            // Latch the flag only when init actually succeeded, so a silent failure
            // leaves it false and a later prop update retries instead of permanently
            // disabling analytics.
            if (!isMixpanelReady()) {
                return;
            }
            this.mixpanelStarted = true;

            // Identity is best-effort and must not block the page view: keep it in
            // its own try/catch so a context-endpoint failure still emits the view.
            try {
                const context = await getTrackEventContext();
                const globalUserId = context && (context.globalUserId || context.global_user_id);
                const accountId = context && (context.accountId || context.account_id);
                if (globalUserId) {
                    identifyMixpanelUser(globalUserId, accountId);
                }
            } catch (identityError) {
                // eslint-disable-next-line no-console
                console.error('Failed to identify Mixpanel user:', identityError);
            }

            // Emit the initial page view here: the landing route's AnalyticsWrapper
            // mounts before Mixpanel is ready, so it skips the module/page-view sync.
            const pathname = this.props.location.pathname;
            setGlobalContextProperty('module', getModuleFromPath(pathname));
            trackPageView(getPageFromPath(pathname));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to setup Mixpanel analytics:', error);
        } finally {
            this.mixpanelStarting = false;
        }
    }

    registerMessageHandler() {
        let self = this;
        window.addEventListener('message', receiveMessage, false);

        function receiveMessage(event) {
            if (event.origin === 'http://localhost:3001') {
                if (event.data.action === 'navigate') {
                    self.props.history.push(event.data.params);
                }
            }
        }
    }

    handleDrag(e) {
        e.preventDefault();
    }

    getToolbarPaths() {
        return ['/',
                RoutesC.HOME,
                RoutesC.SEARCH_RESULT,
                RoutesC.SCOREBOARD_PATH,
                RoutesC.SERVICE_CATALOG_PATH_PARAM,
                RoutesC.SR_VIEW_PARAM];
    }

    render() {
        const isWithToolbar = this.getToolbarPaths().indexOf(this.props.match.path) !== -1;
		const styleClasses = isWithToolbar ? Cx(Style.appContainer, Style.toolbarPadding) : Style.appContainer;
		const chatbotDisplay = this.props.permissionsData.chatBotEnabled ? <Chatbot/> : false;
        const footer = this.props.preferences.footerEnabled ? <Footer/> : false;
		return (
            <ThemeProvider theme={this.props.theme}>
                <StyledDiv className={styleClasses} onDrop={this.handleDrag} onDragOver={this.handleDrag}>
                    <Header/>
                    <Alert/>
                    {this.getToolbarPaths().map((item, index) =>
                                                    <Route exact key={index} component={Toolbar} path={item} />
                    )}
                    <Switch>
                        <Route exact path="/" component={this.withLogHome}/>
                        <Route path={RoutesC.HOME} component={this.withLogHome}/>
                        <Route path={RoutesC.SR_PATH} component={this.withLogIframe}/>
                        <Route path={RoutesC.INCIDENT_PATH} component={this.withLogIframe}/>
                        <Route path={RoutesC.ACTION_PATH_PARAMS} component={this.withLogIframe}/>
                        <Route path={RoutesC.SEARCH_RESULT} component={this.withLogSearchResult}/>
                        <Route path={RoutesC.SCOREBOARD_PATH} component={this.withLogScoreboard}/>
                        <Route path={RoutesC.SR_VIEW_PARAM} component={this.withLogSRview}/>
                        <Route path={RoutesC.REDIRECT_COMP} component={this.withLogRedirect}/>
                        <Route path={RoutesC.MY_SETTINGS_PATH} component={this.withLogMySettings} />
                        <Route path={RoutesC.SERVICE_CATALOG_PATH_PARAM} component={Authorize(this.withLogServiceCatalog)} />
                        <RouterRedirect path="*" to="/" />
                    </Switch>

                    <Charger/>
                    {footer}
                    {chatbotDisplay}
                </StyledDiv>
            </ThemeProvider>
        )
    }
}

App.propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    permissionsData: PropTypes.object.isRequired,
    preferences: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        theme: state.app.get(C.THEME),
        permissionsData: state.app.getIn([C.SSP_PERMISSIONS_LIST]),
        preferences: state.app.getIn([C.SSP_PREFERENCES])
    }
}

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./containers/App/index.js